<template>
  <!-- 班级模拟器训练 -->
  <div class="my-mock">
    <div class="head"></div>
    <div class="mock-box">
      <ul class="mack-menu">
        <li class="div-flex">
          <div class="flex-label">模拟器类型</div>
          <div class="flex-value">
            <van-field readonly clickable name="picker" class="field-color about-teacher"
            :value="model && model.simulatorType"  placeholder="点击选择模拟器类型" @click="showPicker = true" />
            <van-popup v-model="showPicker" position="bottom">
              <van-picker show-toolbar title="模拟器类型" :columns="columnsUsers" @confirm="onConfirm"
                @cancel="showPicker = false" />
            </van-popup>
            <i class="icon-down"></i>
          </div>
        </li>
        <li class="div-flex">
          <div class="flex-label">时间段</div>
          <div class="flex-value" @click="handleShowDataTime">
            <div class="dataTime">
              <div class="dataTime-box">
                <p class="title" v-if="model.dataTime">{{ model && model.dataTime }}</p>
                <p class="desc" v-else>请选择</p>
                <i class="icon-time"></i>
              </div>
            </div>
          </div>
        </li>
        <li class="div-flex">
          <div class="flex-label">地点</div>
          <div class="flex-value">
            <input type="text" maxlength="50" v-model="model.place" placeholder="请输入" class="input-title" />
          </div>
        </li>
        <li class="div-flex">
          <div class="flex-label">目标</div>
          <div class="flex-value">
            <input type="text" maxlength="50" v-model="model.goal" placeholder="请输入" class="input-title" />
          </div>
        </li>
        <li class="div-flex mb12">
          <div class="flex-label-no">其他</div>
        </li>
        <li class="div-flex">
          <div class="flex-value">
            <van-field
              v-model="model.other"
              rows="4"
              autosize
              type="textarea"
              class="input-textarea"
              maxlength="1000"
              placeholder="请输入"
              show-word-limit
            />
          </div>
        </li>
        <li class="div-flex flex-top" @click="handleGo">
          <div class="flex-label">关联内容</div>
          <div class="flex-value">
            <ul class="associated-menu">
              <li class="menu-li" v-for="(acc,index) in changeAboutCon" :key="index">
                <p class="as-title">{{ acc && acc.title }}</p>
                <i class="icon-del" @click.stop="handleClickDel(acc)"></i>
              </li>
            </ul>
          </div>
        </li>
        <addGroup ref="addGroup" :model="model" :classId="areaId" :selectIds="model && model.groupIds" @update:selection="handleSelectionUpdate"></addGroup>
      </ul>
      <div class="confirm-btn" @click="handleAddMackConfirm">确定</div>
    </div>
    <div class="model" v-if="isModelData">
      <div class="model-data">
        <div class="model-head">
          <p class="close" @click="handleModelClose">取消</p>
          <p class="head-title">自定义时间</p>
          <p class="ok" @click="confirmDataOk">确定</p>
        </div>
        <div class="model-main">
          <div class="model-top">
            <div class="main-left">
              <van-field
                readonly
                clickable
                name="datetimePicker"
                :value="cutTime"
                @focus="start"
                placeholder="点击选择开始时间"
                :class="showModalLeftPicker ? 'startTime' : ''"
                @click="handleLeftData"
              />
            </div>
            <span class="hen">-</span>
            <div class="main-right">
              <van-field
                readonly
                clickable
                name="datetimePicker"
                :value="cutRightTime"
                placeholder="点击选择结束时间"
                :class="showModalRightPicker ? 'startTime' : ''"
                @click="handleRightData"
              />
            </div>
          </div>
          <div class="model-btm">
            <van-datetime-picker
            v-if="showModalLeftPicker"
              type="datetime"
              ref="dateTimePicker"
              :min-date="minDate" :max-date="maxDate"
              @change="onDataConfirm"
              :filter="filter"
            />
            <van-datetime-picker
              type="datetime"
              ref="dateTimeRightPicker"
              v-else-if="showModalRightPicker"
              :min-date="minRightDate" :max-date="maxDate"
              @change="onDataRightConfirm"
              :filter="filter"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addClassCard, editClassCard, dictionaryList, classUserPermissions, postCardDetails } from '@/api/grade'
import withRouteTracking from '@/utils/withRouteTracking'
import { debounce, toTimestamp } from '@/utils/util'
import addGroup from './components/addGroup.vue'
const UserProfile = {
  name: 'gradeMock',
  components: {
    addGroup
  },
  data() {
    return {
      checkMockType: false,
      showPicker: false,
      showDataTimePicker: false,
      minDate: new Date(),
      minRightDate: new Date(),
      maxDate: new Date(2050, 12, 31),
      uploadPost: false,
      cutTime: '',
      cutRightTime: '',
      mockTypeList: [],
      columnsUsers: [],
      startTime: '',
      endTime: '',
      areaId: '',
      dccId: '',
      changeAboutCon: [], // 关联内容
      leftPicker: '',
      rightPicker: '',
      isModelData: false,
      showModalLeftPicker: true,
      showModalRightPicker: false,
      contentMaxLength: 1000,
      isAdmin: false,
      model: {
        simulatorType: '',
        other: '',
        goal: '',
        place: '',
        postGroups: []
      }
    }
  },
  computed: {
    // allInput () {
    //   return this.subjectName.length > 0 && this.content.length > 0
    // },
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  async created() {
    this.areaId = this.$route.query.areaId
    this.postId = this.$route.query.postId
    if (this.postId) {
      await this.handleLoad()
    }
    this.classPermissions = JSON.parse(sessionStorage.getItem('classPermissions'))
    if (!(this.classPermissions && this.classPermissions.classId)) {
      this.getClassUserPermissions()
    } else {
      this.isAdmin = this.classPermissions.isAdminPermiss
    }
    this.getDictionaryList()
  },
  async mounted() {
    let changeAboutCon = JSON.parse(localStorage.getItem('changeAboutCon'))
    if (localStorage.getItem('addMockCon')) {
      let storageWorkCon = JSON.parse(localStorage.getItem('addMockCon'))
      this.model = {...storageWorkCon}
      this.$forceUpdate()
    }
    if (changeAboutCon) {
      this.changeAboutCon = [
        ...changeAboutCon.case,
        ...changeAboutCon.course,
        ...changeAboutCon.docc
      ]
    }
  },
  methods: {
    handleSelectionUpdate(ids) {
      // 子组件触发事件，更新父组件的选中集合
      this.model.groupIds = ids
    },
    async handleLoad() {
      await postCardDetails(this.postId).then(res => {
        const data = res.data
        if (data.studyContents.length > 0) {
          data.studyContents.forEach(acc => {
            acc.createTime = this.$moment(data.endTime * 1).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          })
        }
        let startTime = this.$moment(data.startTime * 1).format(
          'YYYY-MM-DD HH:mm'
        )
        let endTime = this.$moment(data.endTime * 1).format(
          'YYYY-MM-DD HH:mm'
        )
        data.dataTime = `${startTime} ~ ${endTime}`
        data.simulatorType = data.simulatorName
        this.model = data
        let changeAboutCon = JSON.parse(localStorage.getItem('changeAboutCon'))
        if (!changeAboutCon) {
          this.changeAboutCon = data.studyContents
          let storageCon = { docc: [], course: [], case: [] }
          data.studyContents.forEach(item => {
            if (item.type === 1) {
              storageCon.docc.push(item)
            } else if (item.type === 2) {
              storageCon.course.push(item)
            } else if (item.type === 3) {
              storageCon.case.push(item)
            }
          })
          localStorage.setItem('changeAboutCon', JSON.stringify(storageCon))
        }
      })
    },
    getClassUserPermissions() {
      const params = {
        classId: this.areaId,
        userId: this.userInfo.id
      }
      classUserPermissions(params).then(res => {
        const data = res.data
        if (this.userInfo.memberType === 1 && data.inClassList) { // 员工
          if ([1, 2].includes(data.roleType)) { // 超管，管理员可以发帖
            this.isAdmin = true
          }
        }
      })
    },
    filter(type, options) {
      if (type === 'minute') {
        return options.filter((option) => option % 15 === 0)
      }
      return options
    },
    handleRightData() {
      // this.minRightDate = new Date(this.cutTime)
      this.minRightDate = new Date()
      this.maxDate = new Date(2050, 12, 31)
      this.showModalLeftPicker = false
      this.showModalRightPicker = true
    },
    handleLeftData() {
      this.minDate = new Date()
      if (this.cutRightTime) {
        this.handleLeftValidate()
        // this.maxDate = new Date(this.cutRightTime)
      } else {
        this.maxDate = new Date(2050, 12, 31)
      }
      this.showModalLeftPicker = true
      this.showModalRightPicker = false
    },
    // 选择开始时间
    start(e) {
      this.showModalLeftPicker = true
    },
    // 选择结束时间
    end(e) {
      this.showModalRightPicker = true
    },
    handleShowDataTime() {
      this.isModelData = true
      this.showModalLeftPicker = true
      this.showModalRightPicker = false
      if (this.model.id) {
        this.cutTime = this.cutTime ? this.$moment(this.cutTime).format('YYYY-MM-DD HH:mm') : this.$moment(this.model.startTime * 1).format('YYYY-MM-DD HH:mm')
        this.cutRightTime = this.cutRightTime ? this.$moment(this.cutRightTime).format('YYYY-MM-DD HH:mm') : this.$moment(this.model.endTime * 1).format('YYYY-MM-DD HH:mm')
      } else {
        this.cutTime = this.cutTime ? this.$moment(this.cutTime).format('YYYY-MM-DD HH:mm') : this.$moment(new Date()).format('YYYY-MM-DD HH:mm')
      }
      this.model.startTime = this.cutTime
    },
    confirmDataOk() {
      if (!this.model.startTime) return this.$toast('开始时间不能为空')
      if (!this.model.endTime) return this.$toast('结束时间不能为空')
      this.isModelData = false
      if (this.model.endTime && this.model.startTime) {
        if (typeof this.model.endTime === 'string' && !this.model.endTime.includes('-')) {
          this.model.endTime = this.$moment(JSON.parse(this.model.endTime)).format('YYYY-MM-DD HH:mm')
        }
        var dateTimeArray = this.model.endTime.split(' ') // 将字符串按空格分割成数组
        const monthDayTime = dateTimeArray[0].substring(5) + ' ' + dateTimeArray[1] // 截取月日时分部分
        this.model.dataTime = `${this.model.startTime}~${monthDayTime}`
      }
      this.minDate = new Date(this.cutTime)
      if (this.cutRightTime) {
        this.handleLeftValidate()
        // this.maxDate = new Date(this.cutRightTime)
      } else {
        this.maxDate = new Date(2050, 12, 31)
      }
      this.showModalLeftPicker = true
      this.showModalRightPicker = false
    },
    onDataConfirm(value, index) {
      const selectedDateTime = this.$refs.dateTimePicker.getPicker().getValues()
      this.cutTime = selectedDateTime.slice(0, 3).join('-') + ' ' + selectedDateTime.slice(3, 5).join(':')
      this.$forceUpdate()
      this.model.startTime = this.cutTime
      this.$forceUpdate()
      this.handleLeftValidate()
      this.handleRightValidate()
    },
    onDataRightConfirm(value) {
      const selectedDateTime = this.$refs.dateTimeRightPicker.getPicker().getValues()
      this.cutRightTime = selectedDateTime.slice(0, 3).join('-') + ' ' + selectedDateTime.slice(3, 5).join(':')
      this.$forceUpdate()
      this.model.endTime = this.cutRightTime
      this.$forceUpdate()
      this.handleRightValidate()
    },
    handleLeftValidate() {
      if (Date.parse(this.model.startTime) > Date.parse(this.model.endTime)) {
        return this.$toast('开始时间不能大于结束时间')
      }
    },
    handleRightValidate() {
      if (Date.parse(this.cutRightTime) < Date.parse(this.model.startTime)) {
        return this.$toast('结束时间必须大于开始时间')
      }
    },
    handleModelClose() {
      this.isModelData = false
      this.showModalLeftPicker = false
      this.showModalRightPicker = false
      this.cutRightTime = ''
      this.cutTime = ''
    },

    handleGo() {
      localStorage.setItem('addMockCon', JSON.stringify(this.model))
      this.$router.push({
        path: `/gradeAboutContent?areaId=${this.areaId}&dccId=${this.dccId || ''}&from=gradeMock`
      })
    },
    // 删除关联内容
    handleClickDel (item) {
      this.changeAboutCon = this.changeAboutCon.filter(
        res => res.id !== item.id
      )
      let changeAboutCon = JSON.parse(localStorage.getItem('changeAboutCon'))
      changeAboutCon.case = changeAboutCon.case.filter(
        res => res.id !== item.id
      )
      changeAboutCon.course = changeAboutCon.course.filter(
        res => res.id !== item.id
      )
      changeAboutCon.docc = changeAboutCon.docc.filter(
        res => res.id !== item.id
      )
      localStorage.setItem('changeAboutCon', JSON.stringify(changeAboutCon))
    },
    onConfirm (value) {
      const list = this.mockTypeList.filter(acc => acc.value === value)
      this.model.simulatorType = value
      this.model.simulatorTypeId = list[0].id
      this.showPicker = false
    },
    getPlainTextLen(richText) {
      return richText
        .replace(/<[^>]+>/g, '')
        .replace(/ |\n|\r\n|&nbsp;|&ensp;/g, '')
        .replace(/[a-zA-Z]&#7([6-7][0-9]);/g, ' ')
        .replace(/&([a-z]{2,5}|#[0-9]{1,6});/g, ' ')
        .length
    },
    // 提交帖子
    handleAddMackConfirm: debounce(async function() {
      if (!this.model.simulatorType) {
        this.$toast('请选择模拟器类型')
        return
      }
      if (!this.model.startTime) {
        this.$toast('请选择时间段')
        return
      }
      if (!this.model.endTime) {
        this.$toast('请选择时间段')
        return
      }
      if (Date.parse(this.model.startTime) > Date.parse(this.model.endTime)) {
        return this.$toast('开始时间不能大于结束时间')
      }
      if (!this.model.place) {
        this.$toast('请输入地点')
        return
      }
      if (!this.model.goal) {
        this.$toast('请输入目标')
        return
      }
      if (this.getPlainTextLen(this.model.other) > this.contentMaxLength) {
        this.$toast('字数超过1000！')
        return
      }
      if (!this.changeAboutCon.length) {
        this.$toast('请选择关联内容')
        return
      }
      if (this.uploadPost) return
      if (!this.isAdmin) {
        this.$toast('暂无权限发帖！')
        this.$router.push({
          path: `/gradeHomePage?classId=${this.areaId}`
        })
        return
      }
      let changeAboutCon = await this.handleAboutConSet()
      this.uploadPost = true
      const { startTime, simulatorTypeId, endTime, place, goal, other } = this.model
      let params = {
        id: this.postId,
        areaId: this.areaId,
        type: '8',
        userId: this.userInfo.id,
        simulatorType: simulatorTypeId,
        startTime: toTimestamp(startTime),
        endTime: toTimestamp(endTime),
        place,
        goal,
        other,
        workDataAddROS: changeAboutCon,
        kind: '4',
        groupIds: this.model.groupIds || [],
        // 5班级发帖6iep课程7线上答疑8模拟器练习
        postType: '8'
      }

      if (params.id) {
        editClassCard(params).then(res => {
          this.$toast('发布成功')
          localStorage.removeItem('addMockCon')
          localStorage.removeItem('changeAboutCon')
          setTimeout(() => {
            this.$router.push({
              path: `/gradeHomePage?classId=${this.areaId}`
            })
          }, 1500)
        }).catch((err) => {
          this.$toast(err.msg)
          this.uploadPost = false
        })
      } else {
        delete params.id
        addClassCard(params).then(res => {
          this.$toast('发布成功')
          localStorage.removeItem('addMockCon')
          localStorage.removeItem('changeAboutCon')
          setTimeout(() => {
            this.$router.push({
              path: `/gradeHomePage?classId=${this.areaId}`
            })
          }, 1500)
        }).catch((err) => {
          this.$toast(err.msg)
          this.uploadPost = false
        })
      }
    }, 500),
    handleAboutConSet() {
      let obj = {}
      let list = []
      this.changeAboutCon.filter(acc => {
        obj = {
          userId: this.userInfo.id,
          title: acc.title,
          type: acc.type,
          baseId: acc.baseId,
          cover: acc.coverUrl,
        }
        list.push(obj)
      })
      return list
    },
    // 获取模拟器类型
    getDictionaryList() {
      const params = {
        typeCode: 'CLASS_SIMULATOR_TYPE',
        dataStatus: '1'
      }
      dictionaryList(params).then(res => {
        const data = res.data
        this.mockTypeList = data
        this.columnsUsers = data.map(item => item.value)
      })
    },
  },

}
export default withRouteTracking(UserProfile)
</script>

<style scoped lang="less">
.my-mock{
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 999;
  background-color: #F9F8F7;
  padding: 22px 10px 20px;
  box-sizing: border-box;
  &::before{
    content:"";
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 146px;
    background-image: url('../../assets/images/grade/mock-bg.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .head{
    background: url('../../assets/images/grade/mock-title.png') no-repeat center center / 100% 100%;
    width: 102px;
    height: 21px;
    position: relative;
    z-index: 66;
    margin-bottom: 14px;
  }
  .mock-box{
    position: relative;
    background: #fff;
    // background: linear-gradient( 180deg, rgba(255,91,12,0.1) 10%, rgba(255,91,12,0) 100%), #FFFFFF;
    border-radius: 12px;
    border: 1px solid #FFFFFF;
    width: 100%;
    flex: 1;
    position: relative;
    height: calc(100vh - 80px);

    .mack-menu{
      position: relative;
      z-index: 2;
      margin:0;
      padding:24px 10px 40px;
      height: calc(100% - 35px - 82px);
      position: relative;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      .div-flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // height: 42px;
        box-sizing: border-box;
        margin-bottom: 30px;
      }
      .mb12{
        margin-bottom: 12px;
      }
      .mb0{
        margin-bottom: 0;
      }
      .flex-top{
        align-items: baseline;
      }
      .flex-label, /deep/ .field-color-request .van-field__label, .label-txt{
        font-size: 14px;
        color: rgba(0,0,0,0.6);
        line-height: 20px;
        padding-left: 8px;
        box-sizing: border-box;
        position: relative;
        &::before {
          content: "*";
          font-size: 14px;
          color: #FF3C3C;
          width: 12px;
          line-height: 20px;
          position: absolute;
          top: 3px;
          left: 0;
          box-sizing: border-box;
        }
      }
      .flex-label-no{
        font-size: 14px;
        color: rgba(0,0,0,0.6);
        line-height: 20px;
        padding-left: 8px;
        box-sizing: border-box;
        position: relative;
      }
      /deep/ .van-cell{
        background: none !important;
        padding:10px 0 !important;
      }
      /deep/ .van-cell::after{
        border-bottom: none !important;
      }
      /deep/ .van-field__control:read-only{
        text-align: right !important;
      }
      .flex-value{
        flex: 1;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: end;
        .input-title{
          width: 85%;
          border:none;
          text-align: right;
          flex: 1;
        }
        .dataTime{
          flex: 1;
          text-align: right;
          align-items: center;
          justify-content: end;
          .dataTime-box{
            text-align: right;
            display: flex;
            align-items: center;
            justify-content: end;
            .desc{
              color: #AEAEAE;
              font-weight: 500;
              font-size: 14px;
              flex: 1;
            }
            .title{
              color: #323233;
              font-weight: 500;
              font-size: 14px;
              flex: 1;
            }
          }
        }
        .desc{
          color: #AEAEAE;
          font-weight: 500;
          font-size: 14px;
        }
        .input-textarea{
          height: 128px;
          max-height: 228px;
          overflow-y: scroll !important;
          background: #F9F9F9 !important;
          padding:10px !important;
          border-radius: 4px;
        }
        .icon-down{
          background: url('../../assets/images/grade/drop-down.png') no-repeat center center / 100% 100%;
          width: 11px;
          height: 6px;
          display: inline-block;
          margin-left: 4px;
        }
        .icon-time{
          background: url('../../assets/images/grade/icon-time.png') no-repeat center center / 100% 100%;
          width: 15px;
          height: 14px;
          display: inline-block;
          margin-left: 4px;
        }
        .associated-menu{
          margin:0;
          text-align: right;
          .menu-li {
            display: flex;
            align-items: center;
            text-align: right;
            .as-title{
              font-size: 14px;
              color: #EB1700;
              white-space: nowrap;
              text-align: right;
              width: 180px;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .icon-del{
              background: url('../../assets/images/grade/icon-del.png') no-repeat center center / 100% 100%;
              width: 16px;
              height: 16px;
              margin-left: 8px;
              position: relative;
              z-index: 4;
            }
          }

        }
      }
    }
    .confirm-btn {
      position: fixed;
      bottom: 34px;
      left: 14px;
      width: calc(100vw - 28px);
      height: 42px;
      border-radius: 100px;
      font-size: 16px;
      text-align: center;
      line-height: 42px;
      font-weight: 500;
      color: #fff;
      background-color: #EB1700;
    }
  }
}
.radio2 {
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  margin: 0 14px;
  box-sizing: border-box;
  position: relative;
  min-height: 24px;

  &::before {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0;
    top: 0;
    left: 0;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  &::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 0;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  .label-txt {
    font-size: 14px;
    color: #343434;
    line-height: 20px;
  }

  .con-txt {
    height: 200px;
    width: 200px;
    overflow-y: auto;
  }

  .txt-div {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    &:nth-last-child(1) {
      margin-bottom: 0;
    }

    .txt {
      color: #EB1700;
      font-size: 14px;
      white-space: nowrap;
      width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .icon-txt {
      width: 16px;
      height: 16px;
      margin-left: 10px;
    }
  }
}
.model{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: rgba(0,0,0,0.6);
  .model-data{
    width: 100%;
    box-sizing: border-box;
    height: 50vh;
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    padding:10px 16px 20px;
    z-index: 2;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    &::before{
      content:"";
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      background: url('../../assets/images/grade/mock-box-bg.png') no-repeat center center / 100% 100%;
      width: 100%;
      height: 63px;
    }
    .model-head{
      width: 100%;
      display: flex;
      font-size: 14px;
      font-weight: 400;
      position: relative;
      z-index: 3;
      .close{
        color: #000000;
      }
      .head-title{
        flex: 1;
        text-align: center;
        font-weight: 600;
        color: #000000;
      }
      .ok{
        color: #EB1700;
      }
    }
    .model-main{
      margin-top: 16px;
      .model-top {
        display: flex;
        align-items: center;
        .main-left{
          flex: 1;
          /deep/ .van-cell{
            height: 38px !important;
            border:1px solid #AEAEAE;
            background: #F0F1F6;
            border-radius: 8px;
          }
          /deep/ .van-field__control{
            line-height: 18px !important;
            font-family: PingFang HK, PingFang HK;
            font-weight: 500;
            color: #AEAEAE;
          }
        }
        .hen{
          width: 6px;
          margin:0 4px;

        }
        .main-right{
          flex: 1;
          /deep/ .van-cell{
            height: 38px !important;
            border:1px solid #AEAEAE;
            background: #F0F1F6;
            border-radius: 8px;
          }
          /deep/ .van-field__control{
            line-height: 18px !important;
          }
        }
        .startTime {
          /deep/ .van-field__control {
            color: #000;
            font-weight: 600;
            &::placeholder {
              color: #000;
              font-weight: 600;
            }
          }
        }
      }
      .model-btm {
        margin-top: 20px;
      }
    }

    /deep/ .van-popup, .van-picker{
      background: transparent !important;
    }
    /deep/ .van-popup {
      height: 45%;
    }
    /deep/ .van-picker__toolbar{
      display: none !important;
    }
  }
}
/deep/ .flex-value{
  /deep/ .van-overlay {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index:2005;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
    // background: transparent !important;
  }
  /deep/.van-popup{
    position: fixed;
    left: 0;
    bottom: 0;
    z-index:2005;
    width: 100%;
    height: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/grade/gradeMock.vue